import { render } from "./TemplateList.vue?vue&type=template&id=845f0246&scoped=true&ts=true"
import script from "./TemplateList.vue?vue&type=script&lang=ts"
export * from "./TemplateList.vue?vue&type=script&lang=ts"

import "./TemplateList.vue?vue&type=style&index=0&id=845f0246&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-845f0246"]])

export default __exports__